
import menu from './menu.json'

export const ca = {
  menu
}
